import axios from "axios";

export default axios.create({
  // baseURL: "https://arresturanttestapi.smartvillageqatar.com/",

  // restui link
  baseURL: "https://restaurantapitest.smartvillageqatar.com/",
});
